export const CABLE_MODE = 'CABLE'
export const DATA_CENTER_MODE = 'DATA_CENTER_MODE'
